import { useCallback, useEffect, useRef } from 'react';

import { InboxFeatureBanner } from './InboxFeatureBanner';

import { INBOX_ANNOUNCEMENT_BANNER } from '@/constants/inboxFeatureBanners';
import {
  useInboxFeatureBannerAnnouncementId,
  useInboxFeatureBannerContent,
} from '@/hooks/inbox/useInboxFeatureBannerContent';
import {
  trackInboxAnnouncementBannerDismissed,
  trackInboxAnnouncementBannerViewed,
} from '@/util/analyticsEvents';

export function InboxAnnouncementBanner({ onDismiss }: { onDismiss: () => void }) {
  const config = INBOX_ANNOUNCEMENT_BANNER;

  const content = useInboxFeatureBannerContent(config);

  const announcementId = useInboxFeatureBannerAnnouncementId(config);

  const hasTrackedViewed = useRef(false);

  useEffect(() => {
    if (!content || !announcementId || hasTrackedViewed.current) {
      return;
    }

    hasTrackedViewed.current = true;

    trackInboxAnnouncementBannerViewed({ announcementId });
  }, [announcementId, content]);

  const handleDismiss = useCallback(() => {
    if (announcementId) {
      trackInboxAnnouncementBannerDismissed({ announcementId });
    }

    onDismiss();
  }, [announcementId, onDismiss]);

  if (!content) {
    return null;
  }

  return (
    <InboxFeatureBanner
      badgeLabel={content.badgeLabel}
      title={content.title}
      description={content.description}
      dismissAccessibilityLabel={content.dismissAccessibilityLabel}
      onDismiss={handleDismiss}
    />
  );
}
